<template>
  <Popup v-bind="$attrs" v-on="$listeners" btnText="确定" :isClose="true" :canClick="checkInputVal">
    <input
      maxlength="4"
      v-model="inputPicVal"
      placeholder="请输入图形验证码"
      class="inputPic"
      type="text"
    />
    <div class="imgCode">
      <img @click="clickImgCode" :src="imgUrl" alt="" />
    </div>
  </Popup>
</template>
<script>
import Popup from '@/components/Popup.vue';

export default {
  name: 'CodePopup',
  data() {
    return {
      inputPicVal: '',
    };
  },
  props: {
    imgUrl: String,
    isShow: Boolean,
  },
  components: {
    Popup,
  },
  computed: {
    checkInputVal() {
      if (this.inputPicVal.length === 4) {
        return false;
      }
      return true;
    },
  },
  watch: {
    inputPicVal: {
      handler(val) {
        this.$emit('getInputPicVal', val);
      },
      immediate: true,
    },
    isShow: {
      handler(val) {
        if (!val) {
          this.inputPicVal = '';
        }
      },
      immediate: true,
    },
  },
  methods: {
    clickImgCode() {
      this.$emit('sendPicCode');
    },
  },
};
</script>
<style scoped>
.imgCode {
  flex: 1;
  height: 40px;
  background: #fafafa;
}
.imgCode img {
  padding: 10px;
  margin-left: 32px;
}
input::-webkit-input-placeholder {
  color: #b8c4cc;
}
input::-moz-input-placeholder {
  color: #b8c4cc;
}
input::-ms-input-placeholder {
  color: #b8c4cc;
}
.inputPic {
  border: 0;
  width: 50%;
}
</style>
